import { ConfigResource } from "@/services";
import * as types from "../mutation-types";

// initial state
const state = {
  all: {
    logoutRoutes: [],
    countries: [],
    recaptcha: null
  }
};

// getters
const getters = {
  getCountries: state => state.all.countries,
  getRecaptcha: state => state.all.recaptcha,
  getLogoutRoutes: state => {
    return JSON.parse(JSON.stringify(state.all.logoutRoutes));
  }
};

// actions
const actions = {
  getCountriesData({ commit }) {
    return ConfigResource.get({
      type: "country"
    })
      .then(response => {
        commit(types.RECEIVE_COUNTRIES, response.body);
      })
      .catch(err => {
        commit(types.RECEIVE_COUNTRIES, []);
      });
  },
  getRecaptchaData({ commit }) {
    return ConfigResource.get({
      type: "recaptcha"
    })
      .then(response => {
        commit(types.RECEIVE_RECATCHA, response.body);
      })
      .catch(err => {
        commit(types.RECEIVE_RECATCHA, null);
      });
  },
  getLogoutRoutesData({ commit }) {
    return ConfigResource.get({
      type: "logout"
    })
      .then(response => {
        commit(types.RECEIVE_LOGOUT_ROUTES, response.body);
      })
      .catch(err => {
        commit(types.RECEIVE_LOGOUT_ROUTES, []);
      });
  }
};

// mutations
const mutations = {
  [types.RECEIVE_COUNTRIES](state, countries) {
    state.all.countries = countries;
  },
  [types.RECEIVE_RECATCHA](state, response) {
    state.all.recaptcha = response;
  },
  [types.RECEIVE_LOGOUT_ROUTES](state, routes) {
    state.all.logoutRoutes = routes;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
